import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export function BooleanDisplay({ value }) {
  return (typeof value === 'boolean' && value) ||
    value?.toString().toLowerCase() === 'true' ? (
    <FormattedMessage defaultMessage="True" id="f827c" />
  ) : (
    <FormattedMessage defaultMessage="False" id="f8320" />
  );
}

BooleanDisplay.propTypes = {
  value: PropTypes.oneOfType([(PropTypes.bool, PropTypes.string)]),
};
BooleanDisplay.defaultProps = {
  value: 'False',
};

export default { BooleanDisplay };
